"use client"

import { ScrollView } from "react-native"
import { styled } from "nativewind"
import { ComponentProps } from 'react';

export const ScrollBox = styled(ScrollView)
export type ScrollBoxProps = ComponentProps<typeof ScrollBox>
